const initialState = {
  clients: [],
  suppliers: [],
  customers: [],
  expenses: [],
  selectedClient: null,
  clientTransactions: [],
  loading: false,
  actionLoading: false,
  error: null,
  totalRecords: 0,
  supplierTotal: 0,
  customerTotal: 0,
  expenseTotal: 0
};

const ClientReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch All Clients
    case 'FETCH_CLIENTS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_CLIENTS_SUCCESS':
      return {
        ...state,
        loading: false,
        clients: action.payload.clients || [],
        totalRecords: action.payload.total || 0,
        error: null
      };
    case 'FETCH_CLIENTS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Fetch Suppliers
    case 'FETCH_SUPPLIERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_SUPPLIERS_SUCCESS':
      return {
        ...state,
        loading: false,
        suppliers: action.payload.clients || [],
        supplierTotal: action.payload.total || 0,
        error: null
      };
    case 'FETCH_SUPPLIERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Fetch Customers
    case 'FETCH_CUSTOMERS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_CUSTOMERS_SUCCESS':
      return {
        ...state,
        loading: false,
        customers: action.payload.clients || [],
        customerTotal: action.payload.total || 0,
        error: null
      };
    case 'FETCH_CUSTOMERS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'FETCH_EXPENSES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_EXPENSES_SUCCESS':
      return {
        ...state,
        loading: false,
        expenses: action.payload.clients || [],
        expenseTotal: action.payload.total || 0,
        error: null
      };
    case 'FETCH_EXPENSES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Get Client By ID
    case 'GET_CLIENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'GET_CLIENT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        selectedClient: action.payload,
        error: null
      };
    case 'GET_CLIENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Create Client
    case 'CREATE_CLIENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'CREATE_CLIENT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        clients: [...state.clients, action.payload],
        error: null
      };
    case 'CREATE_CLIENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Update Client
    case 'UPDATE_CLIENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'UPDATE_CLIENT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        clients: state.clients.map((client) => (client.id === action.payload.id ? action.payload : client)),
        suppliers: state.clients.map((supplier) => (supplier.id === action.payload.id ? action.payload : supplier)),
        customers: state.clients.map((customer) => (customer.id === action.payload.id ? action.payload : customer)),
        expenses: state.expenses.map((expense) => (expense.id === action.payload.id ? action.payload : expense)),
        selectedClient: action.payload,
        error: null
      };
    case 'UPDATE_CLIENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Delete Client
    case 'DELETE_CLIENT_REQUEST':
      return { ...state, actionLoading: true, error: null };
    case 'DELETE_CLIENT_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        clients: state.clients.filter((client) => client.id !== action.payload),
        suppliers: state.clients.filter((supplier) => supplier.id !== action.payload),
        customers: state.clients.filter((customer) => customer.id !== action.payload),
        expenses: state.expenses.filter((expense) => expense.id !== action.payload),
        error: null
      };
    case 'DELETE_CLIENT_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    // Get Client Transactions
    case 'FETCH_CLIENT_TRANSACTIONS_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_CLIENT_TRANSACTIONS_SUCCESS':
      return {
        ...state,
        loading: false,
        clientTransactions: action.payload || [],
        error: null
      };
    case 'FETCH_CLIENT_TRANSACTIONS_FAILURE':
      return { ...state, loading: false, error: action.payload };

    // Clear Selected Client
    case 'CLEAR_SELECTED_CLIENT':
      return { ...state, selectedClient: null };

    // Clear Error
    case 'CLEAR_CLIENT_ERROR':
      return { ...state, error: null };

    default:
      return state;
  }
};

export default ClientReducer;
